import './NotFound.scss';
import React, {useEffect, useState} from "react";
import logo_fa from "../../assets/images/logo_fa.svg";
import T from "../../shared/component/t/T";
import Header from "../Panel/Header/header";
import Footer from "../Panel/Footer/footer";
import {default as _} from "../../helpers/Translate";

export default function NotFound(props) {
    const [headerFooter] = useState(props?.headerFooter ?? true)

    useEffect(() => {
        if (props.nested === undefined) document.title = _.init("title_404");
    },[props.nested]);

    return (
        <>
            {headerFooter && <Header/>}
            <div className={"notFound"} style={{
                backgroundImage: `url(/common/img/404.jpg)`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className={"center"} >
                    <div className={"logo"}>
                        <img  src={logo_fa}  alt="" />
                    </div>
                    <div className={"text"}>
                        <T token={"not_found"}/>
                    </div>
                </div>
            </div>
            {headerFooter && <Footer/>}
        </>
    )
};

